module.exports = __webpack_public_path__ + "media/images/about-us/PGA/Wisconsin PGA-0f1215c07e24fb7f9e11bf198dca13eb.png";